<template>
  <base-page-layout title="Consultar benefícios">
    <div class="d-flex flex-column justify-center align-center mt-8">
      <span class="gray-title">Qual tipo de informação você quer consultar?</span>
      <div :class="['cards-grid', cardsWrapperClass]">
        <mf-square-button icon="sell" text="Ofertas e descontos" @click="goToOffersDiscounts" />
        <mf-square-button icon="currency_exchange" text="Cashback" @click="goToCashback" />
        <mf-square-button
          v-if="$getAllowedModules()['consumer_activation_after_sign_up']"
          icon="identity_platform"
          text="Ativação de cadastro"
          @click="goToSignupActivation"
        />
        <mf-square-button v-if="$getAllowedModules()['ze_delivery']" @click="goToVoucherZe">
          <template>
            <img :src="require('@/assets/icons/consultar-ze.png')" alt="icone-ze" />
            <span>Voucher - Zé Compensa</span>
          </template>
        </mf-square-button>
        <mf-square-button v-if="$getAllowedModules()['points']" @click="goToPoints">
          <template>
            <img :src="require('@/assets/icons/codicon:activate-breakpoints.svg')" alt="icone-pontos" />
            <span>Pontos & Vale-troca</span>
          </template>
        </mf-square-button>
      </div>
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'

export default {
  components: {
    BasePageLayout,
  },
  computed: {
    visibleButtonsCount() {
      /**
       * Retorna a quantidade total de cards visíveis na tela,
       * com base nas permissões de módulo.
       * Essa contagem é usada para ajustar dinamicamente o layout dos botões.
       */
      let count = 2 // Ofertas, Cashback (sempre visíveis)
      if (this.$getAllowedModules()['consumer_activation_after_sign_up'] || this.$getAllowedModules()['ze_delivery'] || this.$getAllowedModules()['points'])
        count++
      return count
    },
    cardsWrapperClass() {
      return {
        'two-buttons': this.visibleButtonsCount === 2,
        'three-buttons': this.visibleButtonsCount === 3,
        'four-buttons': this.visibleButtonsCount >= 4,
      }
    },
  },
  methods: {
    goToOffersDiscounts() {
      this.$router.push({ name: 'consultar-ofertas-descontos' })
    },
    goToCashback() {
      this.$router.push({ name: 'consultar-cashback' })
    },
    goToSignupActivation() {
      this.$router.push({ name: 'consultar-ativacao-cadastro' })
    },
    goToPoints() {
      this.$router.push({ name: 'consultar-pontos' })
    },
    goToVoucherZe() {
      this.$router.push({ name: 'consultar-voucher-ze' })
    },
  },
}
</script>

<style lang="scss" scoped>
.gray-title {
  margin: 16px;
  margin-bottom: 32px;
  color: $cinza-d20;
  font-size: 22px;
  line-height: 26.4px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  text-align: center;
}
.cards-grid {
  display: grid;
  gap: 20px;
  justify-content: center;

  &.two-buttons {
    grid-template-columns: repeat(2, 1fr);
  }

  &.three-buttons {
    grid-template-columns: repeat(3, 1fr);
  }

  &.four-buttons {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 960px) {
  .cards-grid {
    grid-template-columns: 1fr !important;
  }
}
</style>
